<template>
  <div class="page_eleApplication">
    <div class="eleForm">
      <van-form @submit="onSubmit">
        <van-field v-model="dtlForm.StrEmpName" label="姓名" required :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field v-model="dtlForm.StrPhoneNum" @blur="checkPhone(dtlForm.StrPhoneNum)" type="tel" label="手机号" required :rules="[{ required: true, message: '请填写手机号' }]" />
        <van-field v-model="dtlForm.address" label="家庭地址" />

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :disabled="isSuccess">{{ isSuccess ? '已完成' :
            '提交' }}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RegisterPage',
    data() {
      return {
        dtlForm: {
          name: "",
          PhoneNum: "",
          address: "",
        },
        isSuccess: false,
      }
    },
    async created() {

    },
    methods: {
      checkPhone(val) {
        const regex = /^1[3-9]\d{9}$/;
        if (!regex.test(val)) {
          this.phoneJudge = false;
          this.$toast.fail('请填写正确的手机号码')
        } else {
          this.phoneJudge = true;
        }
      },
      onSubmit() {
        if (!this.phoneJudge) {
          this.$toast.fail('请填写正确的手机号码')
        } else {
          this.$toast({
            duration: 5000,
            type: "success",
            message: "保存成功"
          });
          this.isSuccess = true;
        }
      }
    }
  };
</script>
<style scoped>
  .page_eleApplication {
    background: #fff;
    min-height: 100vh;
  }

  .eleTltle {
    font-weight: 600;
    font-size: 17px;
    text-transform: capitalize;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #fff;
    text-align: center;
  }

  .eleForm {
    /* background: #fff; */
    padding: 20px 0;
  }

  .workExp {
    font-weight: 600;
    font-size: 16px;
    padding-left: 5px;
    margin: 10px 5px;
    padding-top: 10px;
    border-top: 1px solid #ccc;
  }

  .topLine {
    border-top: 1px solid #ccc;
    margin-bottom: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    color: #F56C6C;
    font-size: 20px;
    cursor: pointer;
  }

  .signature-container {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }

  .signature-container canvas {
    width: 100%;
    height: auto;
    /* 或固定高度，如 300px */
    max-width: 100%;
    display: block;
    border: 1px solid #ccc;
    background-color: #fff;
  }
</style>
<style>
  .page_eleApplication .van-field__control::placeholder {
    color: #ee0a24;
    font-size: 12px;
  }

  .page_eleApplication .van-icon-photograph:before {
    font-size: 26px;
  }

  .page_eleApplication .el-loading-spinner {
    top: 50vh;
  }
</style>